"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossIcon = void 0;
const React = __importStar(require("react"));
function CrossIcon(props) {
    return (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", tabIndex: -1 }, props),
        React.createElement("path", { fill: "#fff", d: "M18 7.09L16.91 6 12 10.91 7.09 6 6 7.09 10.91 12 6 16.91 7.09 18 12 13.09 16.91 18 18 16.91 13.09 12 18 7.09z", opacity: 0.2 })));
}
exports.CrossIcon = CrossIcon;
